module.exports = __webpack_public_path__ + "static/img/app1.1017694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/app1.jpg
// module id = wt8+
// module chunks = 0